import { getGlobalSearchInput } from 'gcs-common/slices/administration/globalSearch/globalSearchSelectors';
import { getTenants, getTenantsPaginationResult } from 'gcs-common/slices/administration/tenants/tenantsSelectors';
import { fetchTenants } from 'gcs-common/slices/administration/tenants/tenantsThunks';
import PropTypes from 'prop-types';
import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SORT_ORDER } from '../../../../constants/sortConstants';
import detailsIcon from '../../../../img/arrow.svg';
import deletedIcon from '../../../../img/delete.svg';
import addCompanyIcon from '../../../../img/plus_white.svg';
import { showSuccessNotification } from '../../../../slices/notifications/ShowNotificationThunk';
import AddFabButton from '../../../AddFabButton/AddFabButton';
import PaginatedTable from '../../../PaginatedTable/PaginatedTable';
import PopUpModal from '../../../PopUpModal/PopUpModal';
import TenantCreate from '../TenantCreate/TenantCreate';
import TenantDelete from '../TenantDelete/TenantDelete';

const columns = [
  {
    Header: 'Name',
    accessor: 'friendlyName',
  },
];

const TenantTable = ({ onTenantSelected, tenantsLoading }) => {
  const tenants = useSelector(getTenants);
  const tenantsPagination = useSelector(getTenantsPaginationResult);
  const globalSearchInput = useSelector(getGlobalSearchInput);

  const dispatch = useDispatch();

  const [createTenant, setCreateTenant] = useState(false);
  const [deleteTenant, setDeleteTenant] = useState(null);

  const accessorToBeSorted = columns.find((element) => element.Header).accessor;
  const [sortedColumnId, setSortedColumnId] = useState(accessorToBeSorted);
  const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASCENDING);

  const loadTenants = useCallback(
    (pageIndex, pageSize, searchQuery) => {
      dispatch(
        fetchTenants({
          pageIndex,
          pageSize,
          searchQuery,
          sortOrder,
          sortedColumnId,
        }),
      );
    },
    [dispatch, sortOrder, sortedColumnId],
  );

  const deleteSelected = useCallback((event, rowData) => {
    event.stopPropagation();
    const { original } = rowData;
    setDeleteTenant(original);
  }, []);

  const tenantIsDeletedSuccessfully = useCallback(() => {
    setDeleteTenant(null);
    dispatch(showSuccessNotification('Erfolgreich entfernt'));
  }, [dispatch]);

  const tenantIsCreatedSuccessfully = useCallback(() => {
    setCreateTenant(false);
    dispatch(showSuccessNotification('Erfolgreich hinzugefügt'));
  }, [dispatch]);

  return (
    <>
      <PaginatedTable
        onRowSelected={onTenantSelected}
        data={tenants}
        columns={columns}
        onPaginationChanged={loadTenants}
        searchInput={globalSearchInput}
        pagination={tenantsPagination}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        sortedColumnId={sortedColumnId}
        setSortedColumnId={setSortedColumnId}
        sortIsLoading={tenantsLoading}
        renderActions={({ row }) => (
          <>
            <img alt="deleted-icon" src={deletedIcon} onClick={(event) => deleteSelected(event, row)} />
            <img alt="details-icon" src={detailsIcon} />
          </>
        )}
      />
      <AddFabButton icon={addCompanyIcon} title="Tenant" onClick={() => setCreateTenant(true)} />
      <PopUpModal title="Neuer Tenant" onRequestClose={() => setCreateTenant(false)} isOpen={createTenant}>
        <TenantCreate onCancel={() => setCreateTenant(false)} onSuccess={tenantIsCreatedSuccessfully} />
      </PopUpModal>
      {deleteTenant && (
        <PopUpModal title="Tenant löschen" onRequestClose={() => setDeleteTenant(null)} isOpen={!!deleteTenant}>
          <TenantDelete
            tenant={deleteTenant}
            onCancel={() => setDeleteTenant(null)}
            onSuccess={tenantIsDeletedSuccessfully}
          />
        </PopUpModal>
      )}
    </>
  );
};

TenantTable.propTypes = {
  onTenantSelected: PropTypes.func.isRequired,
  tenantsLoading: PropTypes.bool.isRequired,
};

export default TenantTable;
